import { ChainId } from '@pancakeswap/sdk'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import styled from 'styled-components'
import type { ReactNode } from 'react'
import { CHAIN_IDS } from 'utils/wagmi'

export const FEE_AMOUNT_DETAIL: Record<
  FeeAmount,
  { label: string; description: ReactNode; supportedChains: ChainId[] }
> = {
  [FeeAmount.LOWEST]: {
    label: '0.01',
    description: 'Best for very stable pairs.',
    supportedChains: CHAIN_IDS,
  },
  [FeeAmount.LOW]: {
    label: '0.05',
    description: 'Best for stable pairs.',
    supportedChains: CHAIN_IDS,
  },
  [FeeAmount.MEDIUM]: {
    label: '0.25',
    description: 'Best for most pairs.',
    supportedChains: CHAIN_IDS,
  },
  // CAD1 launch tier: only the CAD1 launcher can create a 0.5 % pool (factory whitelist), so it is shown for an existing pool only
  [FeeAmount.CAD1]: {
    label: '0.5',
    description: 'CAD1 launch pool',
    supportedChains: [ChainId.BSC],
  },
  [FeeAmount.HIGH]: {
    label: '1',
    description: 'Best for exotic pairs.',
    supportedChains: CHAIN_IDS,
  },
  [FeeAmount.VERY_HIGH]: {
    label: '3',
    description: 'Best for very exotic pairs.',
    supportedChains: CHAIN_IDS,
  },
}
export const SelectContainer = styled.div`
  align-items: flex-start;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 4px;
`
